const ProjectImageCard = ({ image, title }) => {
  return (
    <div className="w-full h-auto rounded-[28px] shadow-lg bg-white overflow-hidden flex items-center justify-center transition-shadow duration-300 relative">
      <div className="relative w-full h-full aspect-video">
        <img
          src={image || "https://via.placeholder.com/600"}
          alt={title}
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
};

export default ProjectImageCard;
